import React from "react";
import { Box, Typography, Divider, Grid2, Paper, IconButton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  INDIAN_RUPEE_SIGN,
  RENTLY_HOME_ICON_COLOR,
} from "../../constant/constant";


const ReviewStep = ({ registerData }) => {
  const { first_name, last_name, email, contact, plan_details } = registerData;

  return (
    <Box sx={{ textAlign: "left", maxWidth: 900, margin: "0 auto", fontFamily: "SFProDisplay-Regular, Helvetica, Arial, sans-serif" }}>

      {/* 1. BASIC DETAILS BLOCK */}
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          mb: 3,
          borderRadius: "8px",
          border: "1px solid #E4E6EB",
          backgroundColor: "#F5F6F7" // Soft Facebook accent box fill
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
          <PersonIcon sx={{ color: "#1877F2" }} /> {/* Interactive Blue Icon Accent */}
          <Typography variant="h6" sx={{ fontWeight: "700", fontSize: "16px", color: "#1C1E21" }}>
            Basic Details
          </Typography>
        </Box>

        <Grid2 container spacing={2.5}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              FIRST NAME
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500" }}>
              {first_name || "—"}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              LAST NAME
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500" }}>
              {last_name || "—"}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              EMAIL ADDRESS
            </Typography>
            <Typography variant="body1" sx={{ color: "#1877F2", fontSize: "15px", fontWeight: "500" }}>
              {email || "—"}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              CONTACT NUMBER
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500" }}>
              {contact || "—"}
            </Typography>
          </Grid2>
        </Grid2>
      </Paper>

      {/* 3. COMPANY DETAILS BLOCK (Facebook Styled Sub-Card) */}
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: "8px",
          border: "1px solid #E4E6EB",
          backgroundColor: "#F5F6F7"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
          <BusinessIcon sx={{ color: "#1877F2" }} />
          <Typography variant="h6" sx={{ fontWeight: "700", fontSize: "16px", color: "#1C1E21" }}>
            Subscription Plan Details
          </Typography>
        </Box>

        <Grid2 container spacing={2.5}>
          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              PLAN NAME
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500" }}>
              {plan_details.plan_name || "—"}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              PLAN PRICE
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500" }}>
              {`${INDIAN_RUPEE_SIGN} ${plan_details.plan_price}/mo`}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              CORPORATE REGISTRATION ADDRESS
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500", lineHeight: "22px" }}>
              {`Add upto ${plan_details.max_buildings} Buildings`}
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6 }}>
            <Typography variant="caption" sx={{ display: "block", color: "#737373", fontWeight: "600", fontSize: "12px", mb: 0.5 }}>
              CORPORATE REGISTRATION ADDRESS
            </Typography>
            <Typography variant="body1" sx={{ color: "#1C1E21", fontSize: "15px", fontWeight: "500", lineHeight: "22px" }}>
              {`Add upto ${plan_details.max_properties} flats/properties`}
            </Typography>
          </Grid2>
        </Grid2>
      </Paper>

      <Box sx={{ mt: 3, px: 1, textAlign: "center" }}>
        <Typography variant="body2" sx={{ color: "#737373", fontSize: "13px" }}>
          Need to make edits? Click the{" "}
          <Box
            component="span"
            sx={{ display: "inline-flex", verticalAlign: "middle" }}
          >
            <IconButton sx={{ p: 0, color: "#1C1E21" }}>
              <ArrowBackIosNewIcon sx={{ fontSize: "13px" }} />
            </IconButton>
          </Box>{" "}
          icon to adjust your details before finalizing.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReviewStep;
